











import Vue from 'vue';
import { paginator } from '@/util';
import InfiniteLoading from 'vue-infinite-loading';

export default Vue.extend({
  name: 'InfiniteScroller',
  components: {
    InfiniteLoading
  },
  data () {
    return {
      page: 1,
      list: [] as unknown[]
    };
  },
  props: ['data'],
  methods: {
    infiniteHandler ($state: any) {
      paginator(this.data, this.page).then((paginatedResponse: any) => {
        if (paginatedResponse) {
          this.list.push(...paginatedResponse.data);
          if (paginatedResponse.nextPage) {
            this.page += 1;
            $state.loaded();
          } else {
            $state.complete();
          }
        } else {
          $state.complete();
        }
      });
    }
  },
  watch: {
    data () {
      paginator(this.data, 1, this.data.length).then(
        (paginatedResponse: any) => {
          if (paginatedResponse) {
            this.list = paginatedResponse.data;
          }
        }
      );
    }
  }
});
